// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Toast notification */\r\n.toast-body {\r\n    color: #000;\r\n}\r\n\r\n.sidebar {\r\n    background-color: #181818;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
